import { DirhamSymbol } from "dirham-symbol";

export const gxDateFormat = (dateString?: string | null): string => {
  if (!dateString) return "";

  const parsed = new Date(dateString);
  if (Number.isNaN(parsed.getTime())) return "";

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(parsed);
};

export const gxCurrencyAED = (
  amount?: number | string | null,
): React.ReactNode => {
  if (amount === null || amount === undefined || amount === "") return "";

  const value = Number(amount);

  // If not a valid number, return ""
  if (Number.isNaN(value)) return "";

  const formatted = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  // Rule: do NOT show symbol if amount = 0
  if (value === 0) return formatted;

  return (
    <>
      {formatted} <DirhamSymbol />
    </>
  );
};
